import { render } from "./eventSelectorModal.vue?vue&type=template&id=3b53e7ee&scoped=true"
import script from "./eventSelectorModal.vue?vue&type=script&lang=js"
export * from "./eventSelectorModal.vue?vue&type=script&lang=js"

import "./eventSelectorModal.vue?vue&type=style&index=0&id=3b53e7ee&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b53e7ee"]])

export default __exports__